






















import { mapActions } from 'vuex';
import SystemNotify from '@/components/Layout/SystemNotification/SystemNotify.vue';
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import CAlert from '@/components/Layout/CAlert/CAlert.vue';
import CFirebaseAlert from '@/components/Layout/CAlert/CFirebaseAlert.vue';
import { CheeersLayout } from '@/config/routes';
import { fireBase } from '@/helper/notification';
import Drawer from './components/Layout/Drawer/Drawer.vue';
import AppBar from './components/Layout/AppBar/AppBar.vue';
import BlankLayout from './components/Layout/Layouts/Blank.vue';
import DefaultLayout from './components/Layout/Layouts/DefaultLayout.vue';

@Component<App>({
  methods: {
    ...mapActions('staff', ['fetchCurrentStaff']),
  },
  components: {
    CFirebaseAlert,
    CAlert,
    SystemNotify,
    Drawer,
    AppBar,
    BlankLayout,
    DefaultLayout,
  },
})
export default class App extends Vue {
  drawer: boolean = null;

  fetchCurrentStaff!: () => any;

  get layout(): CheeersLayout {
    return this.$route.meta?.layout?.name || this.$route.meta?.layout || 'default';
  }

  get showAppBar(): boolean {
    return (
      this.$route.matched.length > 0 &&
      (!this.$route.meta.layout ||
        this.$route.meta.layout.showAppBar === undefined ||
        this.$route.meta.layout.showAppBar === true)
    );
  }

  get showDrawer(): boolean {
    return (
      this.$route.matched.length > 0 &&
      (!this.$route.meta.layout ||
        this.$route.meta.layout.showDrawer === undefined ||
        this.$route.meta.layout.showDrawer === true)
    );
  }

  get showFooter(): boolean {
    // return (
    //   this.$route.matched.length > 0 &&
    //   (!this.$route.meta.layout ||
    //     this.$route.meta.layout.showFooter === undefined ||
    //     this.$route.meta.layout.showFooter === true)
    // );
    return false;
  }

  created() {
    // listen socket when system maintenance
    this.$cheeers.socket.on('notify_maintenance@updated', ({ flag }) => {
      localStorage.setItem('notify_maintenance', flag);
      if (flag) {
        this.$router.push('/under-maintenance');
      }
    });
    // Listen firebase message
    fireBase.messaging().onMessage((payload) => {
      this.$cheeers.firebaseNotify({
        text: payload.notification.body,
        timeout: 8000,
      });
    });
  }

  @Watch('$route')
  async onRouteChange(to, from) {
    this.$store.dispatch('updateNavigator', to.fullPath);
  }
}
